import videojs from 'video.js';
import '../TimelineIcon/TimelineIcon.scss';
import {notifyWithFullscreenClose} from "../../utiliti";

const ClickableComponent = videojs.getComponent('ClickableComponent');

class PlaylistIcon extends ClickableComponent {
    constructor(player, options) {
        super(player, options);
    }

    createEl() {
        const el = super.createEl('button', {
            className: 'vjs-control vjs-button vjs-chat-icon-section',
            id: 'display-playlist-button'
        });
        this.contentEl_ = videojs.dom.createEl('img', {
            src: 'playlist.svg',
            className: 'vjs-custom-action-icons'
        });
        el.appendChild(this.contentEl_);

        return el;
    }

    handleClick(evt) {
        notifyWithFullscreenClose(this.player_, {type: 'PLAYLIST_CLICKED', currentTime: this.player_.currentTime()})
    }
}

PlaylistIcon.prototype.controlText_ = 'Playlist';

videojs.registerComponent('PlaylistIcon', PlaylistIcon);
